import { SearchOutlined } from '@ant-design/icons';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';
import useDebounce from '@root/core/hooks/useDebounce';
import MypageServices from '@root/modules/Sellers/Mypage/services/mypage';
import { placesAutocomplete } from '@root/utils/helpers/placesAutocomplete';
import { Button, Col, Form, Input, message, Row, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import { AutocompletePrediction } from 'react-places-autocomplete';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from 'use-places-autocomplete';
import '../../../../../styles/pages/seller/_mypage.scss';

const MAJOR_PRODUCT_TYPE_LIST = [
  { id: 1, nameMajor: '패션 용품' },
  { id: 2, nameMajor: 'IT용품' },
  { id: 3, nameMajor: '스포츠용품' },
  { id: 4, nameMajor: '기타' }
];

const MAJOR_CHANEL_LIST = [
  { id: 1, nameMajor: '아마존' },
  { id: 2, nameMajor: '이베이' },
  { id: 3, nameMajor: '라쿠텐' },
  { id: 4, nameMajor: '큐텐' },
  { id: 5, nameMajor: '자사몰' }
];

const { Option } = Select;

interface IAccountSetting {
  id: Number;
  lastName?: string;
  firstName?: string;
  companyName?: string;
  recipientPhoneNumber?: string;
  email?: string;
  userPhone?: Number;
  sellingCountry?: string;
  companyPhone?: Number;
  companyAddress?: string;
  detailAddress?: string;
  detailAddress2?: string;
  detailAddress3?: string;
  city?: string;
  state?: string;
  exportQuantity?: string;
  numberSelling?: string;
  postalCode?: Number;
  country?: string;
  saleCategories?: any;
  saleChannels?: any;
  setImg?: any;
  businessLicense?: any;
  idImg?: any;
  countryCodeCompany?: any;
  countryCodeUser?: any;
}

const SettingAccount = ({
  id,
  lastName,
  firstName,
  companyName,
  email,
  userPhone,
  sellingCountry,
  companyPhone,
  companyAddress,
  detailAddress,
  detailAddress2,
  detailAddress3,
  state,
  city,
  exportQuantity,
  numberSelling,
  postalCode,
  country,
  saleCategories,
  saleChannels,
  setImg,
  businessLicense,
  idImg,
  countryCodeCompany,
  countryCodeUser
}: IAccountSetting) => {
  const [form] = Form.useForm();
  const [licenseUrl, setLicenseUrl] = useState<string>('');
  const inputFile = useRef<HTMLInputElement | null>(null);
  const [countryCode, setCountryCode] = useState<string>('');
  const [countryCodeCompa, setCountryCodeCompa] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [coordinates, setCoordinates] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 0,
    lng: 0
  });
  const [passUse, setPassUse] = useState('');

  const debound = useDebounce(passUse, 1000);
  useEffect(() => {
    setCountryCode(countryCodeUser);
    setCountryCodeCompa(countryCodeCompany);
  }, [countryCodeUser, countryCodeCompany]);

  const handleUploadBusinessFiles = (files: any) => {
    setLicenseUrl(files[0].name);
    form.setFieldsValue({
      businessLicense: files[0]
    });
  };

  const handleBusinessLicenseEvent = (e: any) => {
    const chosenFilesBusinessLicense = Array.prototype.slice.call(e);
    handleUploadBusinessFiles(chosenFilesBusinessLicense);
  };

  useEffect(() => {
    form.setFieldsValue({
      lastName: lastName,
      firstName: firstName,
      companyName: companyName,
      userPhone: userPhone,
      email: email,
      sellingCountry: sellingCountry,
      companyPhone: companyPhone,
      companyAddress: detailAddress,
      detailAddress: detailAddress,
      detailAddress2: detailAddress2,
      detailAddress3: detailAddress3,
      city: city,
      state: state,
      exportQuantity: exportQuantity?.replace('?', '건'),
      numberSelling: numberSelling?.replace('?', '건'),
      postalCode: postalCode,
      country: country,
      saleCategories: saleCategories,
      saleChannels: saleChannels,
      businessLicense: businessLicense,
      countryCodeCompany: countryCodeCompany,
      countryCode: countryCodeUser
    });
    setLicenseUrl(businessLicense);
    setSearchValue(companyAddress ?? '');
    clearSuggestions();
  }, [id]);

  const {
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    debounce: 300
  });
  const refAddress = useOnclickOutside(() => {
    clearSuggestions();
  });
  const handleInput: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (form.getFieldError('searchAddress').length === 0) {
      setCoordinates({
        lat: 0,
        lng: 0
      });
      form.setFieldsValue({
        postalCode: '',
        country: '',
        searchAddress: '',
        city: '',
        state: ''
        // companyAddress: '',
        // streetNum: '',
        // streetRoute: ''
      });
      setValue(e.target.value);
    } else {
      clearSuggestions();
    }
    setSearchValue(e.target.value);
  };

  const handleSelectAddr =
    ({ description }: AutocompletePrediction) =>
    async () => {
      setValue(description, false);
      clearSuggestions();

      const results = await getGeocode({ address: description });
      const { lat, lng } = getLatLng(results[0]);
      setCoordinates({
        lat,
        lng
      });
      setSearchValue(description);
      form.setFieldsValue({
        searchAddress: description
      });
      const address_components = results[0].address_components;
      const { COUNTRY, ZIP_CODE, TOWN, CITY, STATE, NEAREST_ROAD } =
        placesAutocomplete.getAddressComponent(address_components, [
          'COUNTRY',
          'TOWN',
          'CITY',
          'STATE',
          'ZIP_CODE',
          'NEAREST_ROAD'
        ]);
      form.setFieldsValue({
        detailAddress: results[0].formatted_address.split(',')[0]!,
        searchAddress: results[0].formatted_address.split(',')[0]!,
        country: COUNTRY!,
        postalCode: ZIP_CODE!,
        state: STATE ?? CITY!,
        city: TOWN ?? CITY!,
        street: NEAREST_ROAD!
      });
      setSearchValue(results[0].formatted_address.split(',')[0]!);
    };

  const renderSuggestions = () =>
    data.map((suggestion: any) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text }
      } = suggestion;
      return (
        <li
          key={place_id}
          onClick={handleSelectAddr(suggestion)}
          style={{
            padding: '7px',
            borderBottom: '1px solid #d9d9d9'
          }}
        >
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  const handleEditAccount = async (values: any) => {
    try {
      const body = {
        lastName: values.lastName,
        firstName: values.firstName,
        companyName: values.companyName,
        phoneNumber: values.userPhone,
        email: values.email,
        password: values.password,
        sellingCountry: values.sellingCountry,
        companyPhoneNumber: values.companyPhone,
        companyAddress: values.searchAddress,
        detailAddress: values.detailAddress,
        detailAddress2: values.detailAddress2,
        country: values.country,
        state: values.state,
        city: values.city,
        shipmentPerMonth: values.exportQuantity,
        numberOfProduct: values.numberSelling,
        saleCategories: values.saleCategories,
        saleChannels: values.saleChannels,
        postalCode: values.postalCode,
        countryCode: countryCode,
        countryCodeCompany: countryCodeCompa,
        certificate: 0,
        saleArea: values.country,
        password_confirmation: values.rePassword
      };
      const formDataLicense = new FormData();
      formDataLicense.append('file', values.businessLicense);
      if (licenseUrl === businessLicense) {
        body.certificate = idImg;
      } else {
        const uploadImg = await MypageServices.uploadFile(formDataLicense);
        body.certificate = uploadImg.data.id;
      }
      await MypageServices.editAccount(body);
      message.success('Update Info success!');
    } catch (error: any) {
      const { data } = error?.response;
      if (data && data?.message) {
        message.error(data?.message[0]);
      }
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="account-wrapper">
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          lastName: '',
          firstName: '',
          password: '',
          rePassword: '',
          companyName: '',
          userPhone: '',
          sellingCountry: '',
          companyPhone: '',
          companyAddress: '',
          exportQuantity: '',
          numberSelling: '',
          postalCode: '',
          country: '',
          saleCategories: '',
          saleChannels: '',
          email: '',
          businessLicense: ''
        }}
        onFinish={handleEditAccount}
      >
        <Row gutter={[20, 10]}>
          <Col span={12}>
            <Row gutter={[5, 0]}>
              <Col span={12}>
                <Form.Item
                  label="성 "
                  name="lastName"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please enter your last name!'
                  //   }
                  // ]}
                >
                  <Input maxLength={20} />
                </Form.Item>
                <Form.Item
                  label="이메일"
                  name="email"
                  // rules={[
                  //   {
                  //     required: true,
                  //     type: 'email',
                  //     message: 'The input is not valid E-mail!'
                  //   }
                  // ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item>
                  <CountryPhoneInput
                    placeholder="Please enter number only"
                    title="개인 연락처"
                    name="userPhone"
                    defaultCode={countryCodeUser}
                    onchange={(value) => {
                      setCountryCode(`${value}`);
                    }}
                    // phoneNumberRules={[
                    //   {
                    //     required: true,
                    //     message: 'Phone number is required'
                    //   }
                    // ]}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="이름"
                  name="firstName"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please enter your first name!'
                  //   }
                  // ]}
                >
                  <Input maxLength={20} />
                </Form.Item>
                <Form.Item
                  className="input-pass"
                  name="password"
                  label="비밀번호"

                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please enter your first password!'
                  //   }
                  // ]}
                >
                  <Input.Password
                    style={{ padding: '0 11px' }}
                    className="border-input"
                    onChange={(e: any) => {
                      setPassUse(e.target.value);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  className="input-pass --re-pass"
                  name="rePassword"
                  label="비밀번호 재확인"
                  rules={[
                    {
                      required:
                        form.getFieldValue('password') !==
                        form.getFieldValue('rePassword')
                          ? true
                          : false,
                      message: 'Please enter your confirm password!'
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'The two passwords that you entered do not match!'
                          )
                        );
                      }
                    })
                  ]}
                >
                  <Input.Password
                    style={{ padding: '0 11px' }}
                    className="border-input"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row gutter={[5, 5]}>
                  <Col span={12}>
                    <Form.Item
                      label="사업자 등록증"
                      name="businessLicense"
                      // rules={[
                      //   { required: true, message: 'Business licensee is required' }
                      // ]}
                    >
                      <Input.Group compact>
                        <Input
                          style={{ width: 'calc(100% - 110px)' }}
                          className="border-input"
                          value={licenseUrl}
                          readOnly
                          placeholder="Only upload png, jpg, pdf files."
                        />
                        <div className="mypage-wrapper">
                          <Button
                            className="ant-btn attach-btn"
                            type="primary"
                            onClick={() => inputFile?.current?.click()}
                            style={{ borderRadius: '8px' }}
                          >
                            첨부
                          </Button>
                          <input
                            ref={inputFile}
                            className="d-none"
                            type="file"
                            accept=".pdf, .png, .jpg, .jpeg"
                            onChange={(event: any) =>
                              handleBusinessLicenseEvent(event.target.files)
                            }
                          />
                        </div>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="판매국가" name="sellingCountry">
                      <Input maxLength={20} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="majorSign"
                  name="saleCategories"
                  label="판매 카테고리"
                >
                  <Select
                    className="border-input multi-select"
                    placeholder="IT용품, 스포츠용품"
                    mode="tags"
                    size={'middle'}
                  >
                    {MAJOR_PRODUCT_TYPE_LIST.map((item: any) => (
                      <Option
                        key={item.id}
                        value={item.id}
                        style={{ height: 'none' }}
                      >
                        {item.nameMajor}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="majorSign"
                  label="판매 채널"
                  name="saleChannels"
                >
                  <Select
                    className="border-input multi-select"
                    placeholder="이베이, 라쿠텐"
                    mode="tags"
                    size={'middle'}
                  >
                    {MAJOR_CHANEL_LIST.map((item: any) => (
                      <Option key={item.id} value={item.id}>
                        {item.nameMajor}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row gutter={[5, 5]}>
              <Col span={12}>
                <Form.Item label="사업자명" name="companyName">
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item>
                  <CountryPhoneInput
                    placeholder="Please enter number only"
                    title="사업자 연락처"
                    name="companyPhone"
                    defaultCode={countryCodeCompany}
                    onchange={(value) => {
                      setCountryCodeCompa(`${value}`);
                    }}
                    phoneNumberRules={[
                      {
                        required: true,
                        message: 'Phone number is required'
                      }
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[5, 5]}>
              <Col span={24}>
                <Form.Item
                  label="사업장 국가"
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    borderRadius: '7px'
                  }}
                  name="country"
                >
                  <Input
                    className="border-input"
                    disabled
                    placeholder="County/State"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  className="recipient-name"
                  name="searchAddress"
                  label="사업장 주소"
                >
                  <div ref={refAddress}>
                    <Input
                      className="border-input"
                      value={searchValue}
                      onChange={handleInput}
                      placeholder="Search Places ..."
                      suffix={<SearchOutlined id="search-icon" />}
                    />
                    {status === 'OK' && (
                      <ul
                        style={{
                          listStyleType: 'none',
                          padding: 0,
                          background: 'white',
                          borderRadius: '7px',
                          border: '1px solid #d9d9d9',
                          marginTop: '2px',
                          zIndex: 1,
                          position: 'absolute'
                        }}
                      >
                        {renderSuggestions()}
                      </ul>
                    )}
                  </div>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    borderRadius: '7px'
                  }}
                  name="detailAddress3"
                >
                  <Input
                    className="border-input"
                    placeholder="More detail adress"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    borderRadius: '7px'
                  }}
                  name="detailAddress2"
                >
                  <Input
                    className="border-input"
                    placeholder="Apartment, suite, unite, building, floor, etc."
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    borderRadius: '7px'
                  }}
                  name="city"
                >
                  <Input className="border-input" placeholder="Town/City" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    borderRadius: '7px'
                  }}
                  name="state"
                >
                  <Input className="border-input" placeholder="County/State" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    borderRadius: '7px'
                  }}
                  name="postalCode"
                >
                  <Input className="border-input" placeholder="Postal Code" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[5, 5]}>
              <Col span={12} style={{ paddingRight: 9 }}>
                <Form.Item
                  label="월 출고 건수"
                  style={{ width: '100%' }}
                  name="exportQuantity"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please select cargo storage!'
                  //   }
                  // ]}
                >
                  <Select defaultValue="10~49건" className="border-input">
                    <Option value="10~49건">10~49건</Option>
                    <Option value="50~99건">50~99건</Option>
                    <Option value="100~499건">100~499건</Option>
                    <Option value="500~999건">500~999건</Option>
                    <Option value="1000건~">1000건~</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12} style={{ paddingRight: 9 }}>
                <Form.Item
                  label="운영상품 수"
                  style={{ width: '100%' }}
                  name="numberSelling"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please select cargo storage!'
                  //   }
                  // ]}
                >
                  <Select defaultValue="101~1000건" className="border-input">
                    <Option value="101~1000개">101~1000개</Option>
                    <Option value="1~10개">1~10개</Option>
                    <Option value="11~100갯">11~100갯</Option>
                    <Option value="101~1000개">101~1000개</Option>
                    <Option value="1001개~">1001개~</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="container-tag-cancel">
          <div className="button-container">
            <Button className="renueProduct" type="default" htmlType="submit">
              수정 요청
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default SettingAccount;
